(function () {
  'use strict';
  const root = document.querySelector('.cria-guia');
  if (!root) return;

/* ---------- reveal ---------- */
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){
        e.target.classList.add('cg-on');
        io.unobserve(e.target);
      }
    });
  },{threshold:.12,rootMargin:'0px 0px -30px 0px'});
  root.querySelectorAll('.cg-rv').forEach(el=>io.observe(el));

  /* ---------- kibble choreography ---------- */
  // #cg-kibble e position:fixed e precisa se posicionar contra a viewport.
  // Dentro do tema, qualquer ancestral com transform/filter/will-change vira
  // containing block e quebra a coreografia. Movendo pro <body> resolve.
  const kib = root.querySelector('#cg-kibble');
  if (kib && kib.parentElement !== document.body) document.body.appendChild(kib);
  const slots = [...root.querySelectorAll('[data-k]')];
  const scales = [1,.4,.4,.4,.4,.4,.3];
  const landEl = root.querySelector('.cg-landing');
  let landed=false, started=false, cx=0, cy=0, csc=1, crot=0;

  function pts(){
    return slots.map(el=>{
      const r = el.getBoundingClientRect();
      return {x:r.left+r.width/2+scrollX, y:r.top+r.height/2+scrollY};
    });
  }
  const easeIO = t => t<.5 ? 4*t*t*t : 1-Math.pow(-2*t+2,3)/2;
  const plateau = u => easeIO(Math.min(1,Math.max(0,(u-.16)/.68)));

  function target(){
    scales[scales.length-1] = (landEl.clientWidth*.05)/160;
    const P = pts();
    const vh = innerHeight;
    const trigs = P.map(p=>p.y-vh*.52);
    const s = scrollY, n = P.length-1;
    if(s<=trigs[0]) return {x:P[0].x,y:P[0].y,sc:scales[0],rot:0,end:false};
    if(s>=trigs[n]) return {x:P[n].x,y:P[n].y,sc:scales[n],rot:1080,end:true};
    let i=0; while(i<n && s>trigs[i+1]) i++;
    const u=(s-trigs[i])/(trigs[i+1]-trigs[i]), v=plateau(u);
    return {
      x:P[i].x+(P[i+1].x-P[i].x)*v,
      y:P[i].y+(P[i+1].y-P[i].y)*v,
      sc:scales[i]+(scales[i+1]-scales[i])*v,
      rot:(i+v)*160,
      end:false
    };
  }

  function frame(){
    const t = target();
    if(!started){cx=t.x;cy=t.y;csc=t.sc;crot=t.rot;started=true;}
    cx+=(t.x-cx)*.16; cy+=(t.y-cy)*.16;
    csc+=(t.sc-csc)*.16; crot+=(t.rot-crot)*.16;
    kib.style.transform =
      `translate3d(${cx-80}px,${cy-scrollY-62}px,0) rotate(${crot}deg) scale(${csc})`;
    if(t.end && !landed){landed=true; kib.classList.add('cg-land');}
    if(!t.end && landed){landed=false; kib.classList.remove('cg-land');}
    requestAnimationFrame(frame);
  }
  const mq = matchMedia('(prefers-reduced-motion: reduce)');
  if(!mq.matches) requestAnimationFrame(frame);
})();
